
import { dateHelper } from '@/helpers/dateHelper'
import foHeaderLockerPickupPoint from './header/header.vue'
import foFooter from '@/components/footer/footer.vue'
import pickupPointQrCodeViewer from './codeViewer/codeViewer.vue'
import pickupPointBodyViewer from './bodyViewer/bodyViewer.vue'
import { SnackBarType } from '@/store/types'
import mixins from 'vue-typed-mixins'
import { bookingMixin } from '@/mixins'
import { ALLOWED_LOCKER_PICKUP_POINT_BOOKING_STATUSES, ROUTES } from '@/constants'

export default mixins(bookingMixin).extend({
  name: 'mp-locker-pickup-point-infos',
  components: {
    foHeaderLockerPickupPoint,
    foFooter,
    pickupPointQrCodeViewer,
    pickupPointBodyViewer,
  },
  data() {
    return {
      dateHelper,
      hasLoaded: false,
    }
  },
  async mounted() {
    try {
      const {
        query: { language },
      } = this.$route

      const languageToUse = language?.toString() || ''

      await this.getBooking(this.$route.name!, languageToUse)
      if (
        !this.clientPage ||
        !this.booking ||
        !ALLOWED_LOCKER_PICKUP_POINT_BOOKING_STATUSES.includes(this.booking.status)
      ) {
        return this.$router.push({ name: ROUTES.NOT_FOUND })
      }
    } catch (e) {
      await this.$store.dispatch('setSnackbar', {
        message: this.$t('messages.error'),
        type: SnackBarType.ERROR,
      })
    }

    this.hasLoaded = true
  },
  computed: {
    lastName() {
      return this.booking?.Delivery?.delivery?.contact.lastName ?? ''
    },
    endCollectionDate() {
      const timezone = this.booking?.customer.timezone ?? 'Europe/Paris'
      return this.booking?.endCollectionPeriod
        ? dateHelper.formatToTimezone(new Date(this.booking?.endCollectionPeriod), timezone, 'P')
        : ''
    },
  },
})
